import * as Yup from 'yup'

const UserSchema = Yup.object().shape({
    firstName: Yup.string().required('Required'),
    lastName: Yup.string().required('Required'),
    email: Yup.string().email('Invalid email').required('Required'),
    phone: Yup.string()
        .matches(/^[0-9]{10}$/, `Please enter a valid 10-digit phone number.`)
        .required(`Required`),
    employmentType: Yup.string().required('Required'),
    joiningDate: Yup.string().required('Required'),
    earningBonus: Yup.string().required('Required'),
    policy: Yup.string().required('Required'),
    location: Yup.string().required('Required'),
    usertype: Yup.string().required('Required'),
    payfrequency: Yup.string().required('Required'),
    manager: Yup.string().test(
        'required-if-teacher',
        'Required',
        function (value, context) {
            const usertype = context.parent.usertype
            if (usertype === 'Teacher') {
                return value !== undefined && value !== '' // Validate if usertype is 'teacher'
            }
            return true // No validation required if usertype is not 'teacher'
        }
    ),
})

export { UserSchema }
